export default __webpack_public_path__ + "static/media/vertically-split-promotional-wave-background.391004e2.png";